import { AxiosInstance } from 'axios';
import ShiftAutomationRepositoryInterface, {
  ApiCreateShiftAutomationInterface, ApiUpdateShiftAutomationInterface,
  ShiftAutomationInterface,
} from '@/services/Calendar/ShiftAutomation/Interfaces';

export default class ShiftAutomationRepository implements ShiftAutomationRepositoryInterface {
  private apiPrefix = '/calendar/shifts/automations';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllShiftAutomations(): Promise<ShiftAutomationInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getShiftAutomationsForUser(userId: string): Promise<ShiftAutomationInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/user/${userId}`);

    return res.data;
  }

  public async getShiftAutomationsById(id: number): Promise<ShiftAutomationInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/id/${id}`);

    return res.data;
  }

  public async createShiftAutomation(data: ApiCreateShiftAutomationInterface): Promise<boolean> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.status === 201;
  }

  public async updateShiftAutomation(data: ApiUpdateShiftAutomationInterface): Promise<void> {
    await this.axios.patch(this.apiPrefix, data);
  }

  public async deleteShiftAutomation(id: number): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { id } });
  }
}
